import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';

@Injectable()
export class S3Service {
    constructor(private httpClient: HttpClient, private apiEndpointService: ApiEndpointService) {
    }

    public getFile(bucketName: string, fileName: string): Observable<any> {
        const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('downloadFileFromS3'))
                                           .param('bucketName', bucketName)
                                           .param('fileName', fileName)
                                           .toString();

        return this.httpClient.get(endpoint, { responseType: 'text' });
    }

    public getPDFFile(fileName): Observable<any> {
        const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('downloadPDFFileFromS3'))
                                           .param('fileName', fileName)
                                           .toString();
        return this.httpClient.get(endpoint, { responseType: 'text' });
    }

}
